export default "__VITE_ASSET__DxD6eFpE__"